var map = {
	"./arte.svg": "c904",
	"./biologia.svg": "b491",
	"./ciencias.svg": "f95d",
	"./default.svg": "76fc",
	"./filosofia.svg": "e087",
	"./fisica.svg": "7f94",
	"./geografia.svg": "2855",
	"./historia.svg": "d6c2",
	"./lingua_espanhola.svg": "e96e",
	"./lingua_inglesa.svg": "8dbb",
	"./lingua_portuguesa.svg": "0900",
	"./matematica.svg": "1592",
	"./natureza_e_sociedade.svg": "987c",
	"./quimica.svg": "e9d7",
	"./sociologia.svg": "7f9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "125a";